const features = [
  {
    icon: 'ri-stack-line',
    title: '海量资源聚合',
    desc: '一站式聚合香蕉视频、红桃视频、91视频、蜜桃视频等主流平台，覆盖电影、电视剧、综艺、动漫全品类资源，总收录超过10万部影视作品。',
    color: 'primary',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速流畅播放',
    desc: '采用先进的视频加速技术，自适应带宽优化传输，确保高清视频流畅播放不缓冲。支持多线路自动切换，网络波动也不影响观看体验。',
    color: 'accent',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多平台无缝切换',
    desc: '聚合多个视频平台资源于一体，无需跳转即可在香蕉视频、红桃视频、91视频、蜜桃视频之间自由切换，选择最佳播放源。',
    color: 'primary',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '每日实时更新',
    desc: '99视频内容库每日更新，同步各大平台最新上线的影视内容。热门剧集第一时间收录，追剧追番不再错过任何精彩瞬间。',
    color: 'accent',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全免费观看',
    desc: '无需注册登录，无需付费订阅，打开即看完全免费。严格筛选播放源确保内容安全，为您提供纯净无干扰的观影环境。',
    color: 'secondary',
  },
];

const colorMap: Record<string, { iconBg: string; iconText: string; cardBorder: string }> = {
  primary: { iconBg: 'bg-primary-50', iconText: 'text-primary-600', cardBorder: 'hover:border-primary-200/60' },
  accent: { iconBg: 'bg-accent-50', iconText: 'text-accent-600', cardBorder: 'hover:border-accent-200/60' },
  secondary: { iconBg: 'bg-secondary-50', iconText: 'text-secondary-600', cardBorder: 'hover:border-secondary-200/60' },
};

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            平台特色
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            为什么选择99视频？五大核心优势为您打造最佳在线视频观看体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feat, idx) => {
            const c = colorMap[feat.color];
            const isLastFull = idx === features.length - 1 && features.length % 3 !== 0;
            return (
              <article
                key={idx}
                className={`bg-background-100 rounded-2xl p-6 border border-background-200/60 ${c.cardBorder} transition-all duration-300 cursor-pointer group ${
                  isLastFull ? 'lg:col-span-3' : ''
                }`}
              >
                <div className={`w-12 h-12 rounded-xl ${c.iconBg} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-200`}>
                  <i className={`${feat.icon} ${c.iconText} text-xl`}></i>
                </div>
                <h3 className="font-semibold text-foreground-950 text-base mb-2">{feat.title}</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">{feat.desc}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}